import { ChainId } from '@nominex/nomiswap-sdk'
import { tokens } from 'config/tokens'
import { BOOSTING_MIGRATOR_ADDRESSES, MAIN_LAUNCHPOOL_ADDRESS, MAIN_POOL_ID } from './constants'
import { serializePool } from './helpers'
import { PoolCategory, SerializedPoolConfig } from './types'

const pools: SerializedPoolConfig[] = [
  {
    sousId: MAIN_POOL_ID,
    stakingToken: tokens[ChainId.BSC].nmx,
    earningToken: tokens[ChainId.BSC].nmx,
    contractAddress: MAIN_LAUNCHPOOL_ADDRESS,
    migratorAddress: '0xb254F580964C9751DAf2498358061856C2e64994',
    launchpoolAddress: MAIN_LAUNCHPOOL_ADDRESS,
    poolCategory: PoolCategory.CORE,
    harvest: true,
    sortOrder: 1,
    isFinished: false,
    isAutoVault: false,
  },
  {
    sousId: 1,
    stakingToken: tokens[ChainId.BSC].nmx,
    earningToken: tokens[ChainId.BSC].nmx,
    contractAddress: '0x9d130d5B3071e538280D306fFe5867eE45dF8ba3',
    migratorAddress: BOOSTING_MIGRATOR_ADDRESSES,
    launchpoolAddress: '0x57e61dAAe04F8C5FC973493706Ca6E746F62749A',
    poolCategory: PoolCategory.BOOSTING,
    harvest: false,
    sortOrder: 2,
    isFinished: true,
    isAutoVault: true,
    isPromoPool: true,
    isPrivate: true,
    promoPeriodFinish: Date.UTC(2022, 10, 14, 8),
  },
  {
    sousId: 2,
    stakingToken: tokens[ChainId.BSC].nmx,
    earningToken: tokens[ChainId.BSC].nmx,
    contractAddress: '0x19043f29cE831e68bb6ca55dC793ca16859206C8',
    migratorAddress: BOOSTING_MIGRATOR_ADDRESSES,
    launchpoolAddress: '0xD34938BB666672bd21B35aE843f7862D01c2A6bC',
    poolCategory: PoolCategory.BOOSTING,
    harvest: false,
    sortOrder: 3,
    isFinished: true,
    isAutoVault: true,
    isPrivate: true,
  },
  {
    sousId: 3,
    stakingToken: tokens[ChainId.BSC].nmx,
    earningToken: tokens[ChainId.BSC].nmx,
    contractAddress: '0x8385B6155c607aB57781b764CaC0e7159cE0f77e',
    migratorAddress: BOOSTING_MIGRATOR_ADDRESSES,
    launchpoolAddress: '0x714DBA47D77196cDc5e946D05AF2Ca9c88587aC8',
    poolCategory: PoolCategory.BOOSTING,
    harvest: false,
    sortOrder: 4,
    isFinished: true,
    isAutoVault: true,
    isPrivate: true,
  },
  {
    sousId: 4,
    stakingToken: tokens[ChainId.BSC].nmx,
    earningToken: tokens[ChainId.BSC].nmx,
    contractAddress: '0xBf98873a8bC24e55F48DE07786518937Ab261477',
    migratorAddress: BOOSTING_MIGRATOR_ADDRESSES,
    launchpoolAddress: '0x9aA7fE806C563d0d9b855cAb2b2d96942E6b711e',
    poolCategory: PoolCategory.BOOSTING,
    harvest: false,
    sortOrder: 5,
    isFinished: true,
    isAutoVault: true,
    isPrivate: true,
  },
  {
    sousId: 5,
    stakingToken: tokens[ChainId.BSC].nmx,
    earningToken: tokens[ChainId.BSC].nmx,
    contractAddress: '0x27d167A9c5dB2E98727B98DcA125C553eD115AdB',
    migratorAddress: BOOSTING_MIGRATOR_ADDRESSES,
    launchpoolAddress: '0xE3a5Dd26C2d2Bf8043376aefC890064253425Ff5',
    poolCategory: PoolCategory.BOOSTING,
    harvest: false,
    sortOrder: 6,
    isFinished: true,
    isAutoVault: true,
    isPrivate: true,
  },
  {
    sousId: 6,
    stakingToken: tokens[ChainId.BSC].nmx,
    earningToken: tokens[ChainId.BSC].nmx,
    contractAddress: '0x8aB086e58aB656507c50F3Ee0Def3E7e193F36D0',
    migratorAddress: BOOSTING_MIGRATOR_ADDRESSES,
    launchpoolAddress: MAIN_LAUNCHPOOL_ADDRESS,
    poolCategory: PoolCategory.BOOSTING,
    harvest: false,
    sortOrder: 7,
    isFinished: false,
    isAutoVault: true,
  },
  {
    sousId: 7,
    stakingToken: tokens[ChainId.BSC].nmx,
    earningToken: tokens[ChainId.BSC].nmx,
    contractAddress: '0xE44F8dA96856a4352AFDC29211F4D84756F8392b',
    migratorAddress: BOOSTING_MIGRATOR_ADDRESSES,
    launchpoolAddress: MAIN_LAUNCHPOOL_ADDRESS,
    poolCategory: PoolCategory.BOOSTING,
    harvest: false,
    sortOrder: 8,
    isFinished: false,
    isAutoVault: true,
  },
  {
    sousId: 8,
    stakingToken: tokens[ChainId.BSC].nmx,
    earningToken: tokens[ChainId.BSC].nmx,
    contractAddress: '0x387889F3e01E8aD712EB04D4a39A362e89C62aD6',
    migratorAddress: BOOSTING_MIGRATOR_ADDRESSES,
    launchpoolAddress: MAIN_LAUNCHPOOL_ADDRESS,
    poolCategory: PoolCategory.BOOSTING,
    harvest: false,
    sortOrder: 9,
    isFinished: false,
    isAutoVault: true,
  },
  {
    sousId: 9,
    stakingToken: tokens[ChainId.BSC].nmx,
    earningToken: tokens[ChainId.BSC].nmx,
    contractAddress: '0x4EdcB6CAd589C4146D5AeE208356ab874B23D8aD',
    migratorAddress: BOOSTING_MIGRATOR_ADDRESSES,
    launchpoolAddress: MAIN_LAUNCHPOOL_ADDRESS,
    poolCategory: PoolCategory.BOOSTING,
    harvest: false,
    sortOrder: 10,
    isFinished: false,
    isAutoVault: true,
  },
].map(serializePool)

export default pools
